import React from 'react';
import { router, usePage } from '@inertiajs/react';

export default function Music() {
    const { musicAssets, flash = {} } = usePage().props;
    const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
    
    const handleDelete = (id) => {
        if (confirm('Are you sure you want to delete this music asset?')) {
            router.delete(`/admin/music/${id}`);
        }
    };

    return (
        <div className="container mt-4">
            <h1 className="mb-4">Manage Public Music Assets</h1>
            {flash.success && (
                <div className="alert alert-success">
                    {flash.success}
                </div>
            )}
            {flash.error && (
                <div className="alert alert-danger">
                    {flash.error}
                </div>
            )}
            <form method="post" action="/admin/music" encType="multipart/form-data">
                <input type="hidden" name="_token" value={csrfToken} />
                <div className="mb-3">
                    <label htmlFor="name" className="form-label">Music Name:</label>
                    <input type="text" name="name" className="form-control" required />
                </div>
                <div className="mb-3">
                    <label htmlFor="music_file" className="form-label">Upload Music File:</label>
                    <input type="file" name="music_file" className="form-control" accept=".mp3,.wav" required />
                </div>
                <button type="submit" className="btn btn-primary">Upload Music</button>
            </form>

            <h2 className="mt-4">Current Public Music Assets</h2>
            <table className="table">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>URL</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {musicAssets.map(asset => (
                        <tr key={asset.id}>
                            <td>{asset.text}</td>
                            <td><a href={asset.url} target="_blank" rel="noopener noreferrer">Listen</a></td>
                            <td>
                                <button onClick={() => handleDelete(asset.id)} className="btn btn-danger">Delete</button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}
